import React, { useState } from 'react';
import { supabase } from '../../../lib/supabaseClient';

interface Props {
  onClose: () => void;
  onCreated?: (group: any) => void;
}

const CreateGroupDialog: React.FC<Props> = ({ onClose, onCreated }) => {
  const [name, setName] = useState('');
  const [isPublic, setIsPublic] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    if (!name) return;
    setLoading(true);
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (!user) {
      alert('Not authenticated');
      return;
    }
    const { data, error } = await supabase
      .from('groups')
      .insert({ name, is_public: isPublic, creator_id: user.id })
      .select()
      .single();
    if (error) {
      alert(error.message);
      setLoading(false);
      return;
    }

    // Add creator as member (owner)
    await supabase.from('group_members').insert({ group_id: data.id, user_id: user.id, role: 'owner', status: 'active' });
    setLoading(false);
    onCreated?.(data);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded p-6 w-96 space-y-4">
        <h2 className="text-xl font-semibold">Create Group</h2>
        <input
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="Group name"
          className="w-full border rounded p-2"
        />
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={isPublic} onChange={e => setIsPublic(e.target.checked)} /> Public group
        </label>
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="px-3 py-1 text-sm">Cancel</button>
          <button
            onClick={handleCreate}
            disabled={loading}
            className="px-3 py-1 bg-blue-600 text-white rounded text-sm"
          >
            {loading ? 'Creating...' : 'Create'}
          </button>
        </div>
      </div>
    </div>
  );
};
export default CreateGroupDialog; 